import React from "react";
import "./ResultDisplay.css";

/**
 * ResultDisplay component shows the results of calendar update operations
 *
 * @param {Object} props
 * @param {Object} props.results - The results data from calendar update operation
 * @returns {JSX.Element}
 */
const ResultDisplay = ({ results }) => {
  // If no results, don't render anything
  if (!results) return null;

  return (
    <div className="calendar-results">
      <h3>Calendar Update Results</h3>
      <div className="results-summary">
        <p>
          Total events processed: {results.totalProcessed}
          <br />
          Successfully posted: {results.totalSuccessful}
        </p>
      </div>
      <div className="results-details">
        {results.results.map((result, index) => (
          <div
            key={index}
            className={`result-item ${result.success ? "success" : "failure"}`}
          >
            <div className="result-header">
              <span className="result-status">
                {result.success ? "✓ Success" : "✗ Failed"}
              </span>
              <span className="result-id">{result.event}</span>
            </div>
            {!result.success && result.message && (
              <div className="result-message">{result.message}</div>
            )}
            {!result.success && result.error && (
              <div className="result-error">{result.error}</div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ResultDisplay;
